<template>
  <div class="layout-wrapper">
    <div class="page-title">
      <h2>Dashboard</h2>
    </div>
    <macro-metric-list />
    <v-row class="no-gutters">
      <v-col cols="12">
        <enterprise-risk />
      </v-col>
      <v-col cols="12">
        <overview-risk />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MacroMetricList from '../components/Dashboard/MacroMetricList'
import OverviewRisk from '../components/Dashboard/OverviewRisk'
import EnterpriseRisk from '../components/Dashboard/EnterpriseRisk'
export default {
  name: 'Dashboard',
  components: {
    MacroMetricList,
    EnterpriseRisk,
    OverviewRisk
  }
}
</script>
